import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@mademine/components';
import { ReactComponent as PlusIcon } from '../../assets/icon-line-plus.svg';
var AvatarPlaceholder = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, onClick = _a.onClick;
    return (_jsx("div", { className: "".concat(className, " _sz-flex _sz-h-13 _sz-w-13 _sz-items-center _sz-justify-center _sz-rounded-full _sz-border _sz-border-dashed _sz-border-[var(--sunzi-theme-color)] _sz-bg-[var(--sunzi-theme-color-006)]"), onClick: onClick, children: _jsx(Icon, { size: 16, color: "var(--sunzi-theme-color)", children: _jsx(PlusIcon, {}) }) }));
};
export default AvatarPlaceholder;
